import {useMutation} from 'react-query';
import {patchBanText} from '.';
import {AxiosError} from 'axios';
import {toast} from 'react-toastify';
interface IUsePatchBanTextProps {
  guid?: string;
  onSuccessAction: () => void;
}
const usePatchBanText = ({guid, onSuccessAction}: IUsePatchBanTextProps) => {
  const {isLoading, mutate, isSuccess} = useMutation({
    mutationFn: (payload: IUsePatchBanTextPayload) => {
      return patchBanText(payload, guid);
    },
    onSuccess: () => {
      onSuccessAction && onSuccessAction();
    },
    onError: (error: AxiosError<IAxiosErr>) => {
      toast.error(
        error?.response?.data?.message ||
          'مشکلی پیش آمده ،لطفا در زمان دیگری مراجعه فرمایید',
      );
    },
  });

  return {isLoadingBanChat: isLoading, mutateBanChat: mutate, isSuccess};
};

export default usePatchBanText;
